module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-position-1053cf1baf6f763519a1c4c3b81d6c3f.png";